import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import {
  AppHeaderBrand,
  AppHeaderCenter,
  AppHeaderEnd,
  AppHeaderStart
} from "@/zapi-frontend/widgets/Header/ui/blocks/AppHeader";
import { HEADER_CENTER_SLOT_ID } from "../lib/headerSlots";
import { AccountBar } from "./_AccountBar";
import { OrganizationPicker } from "./_OrganizationPicker";

export function PortfolioHeader({ withCenterSlot = true }: { withCenterSlot?: boolean }) {
  const { t } = useTranslation("projectHome");
  return (
    <>
      <AppHeaderStart>
        <AppHeaderBrand
          render={<Link to={getRouteProjects()} data-testid="header-logo-link" />}
          aria-label={t("header.brandLabel")}
        />
      </AppHeaderStart>
      {withCenterSlot && <AppHeaderCenter id={HEADER_CENTER_SLOT_ID} />}
      <AppHeaderEnd>
        <OrganizationPicker />
        <AccountBar />
      </AppHeaderEnd>
    </>
  );
}
